const lib = {};
lib['reaction'] = {}
import reactiongeneral from './reaction/general';
lib['reaction']['general'] = reactiongeneral;

lib['sample'] = {}
import samplechromatogram from './sample/chromatogram';
lib['sample']['chromatogram'] = samplechromatogram;

import samplecyclicVoltammetry from './sample/cyclicVoltammetry';
lib['sample']['cyclicVoltammetry'] = samplecyclicVoltammetry;

import sampledifferentialCentrifugalSedimentation from './sample/differentialCentrifugalSedimentation';
lib['sample']['differentialCentrifugalSedimentation'] = sampledifferentialCentrifugalSedimentation;

import sampledifferentialScanningCalorimetry from './sample/differentialScanningCalorimetry';
lib['sample']['differentialScanningCalorimetry'] = sampledifferentialScanningCalorimetry;

import sampledls from './sample/dls';
lib['sample']['dls'] = sampledls;

import sampleelementAnalysis from './sample/elementAnalysis';
lib['sample']['elementAnalysis'] = sampleelementAnalysis;

import samplegenbank from './sample/genbank';
lib['sample']['genbank'] = samplegenbank;

import samplegeneral from './sample/general';
lib['sample']['general'] = samplegeneral;

import samplehgPorosimetry from './sample/hgPorosimetry';
lib['sample']['hgPorosimetry'] = samplehgPorosimetry;

import sampleicp from './sample/icp';
lib['sample']['icp'] = sampleicp;

import sampleimage from './sample/image';
lib['sample']['image'] = sampleimage;

import sampleir from './sample/ir';
lib['sample']['ir'] = sampleir;

import sampleisotherm from './sample/isotherm';
lib['sample']['isotherm'] = sampleisotherm;

import sampleiv from './sample/iv';
lib['sample']['iv'] = sampleiv;

import samplemass from './sample/mass';
lib['sample']['mass'] = samplemass;

import samplenmr from './sample/nmr';
lib['sample']['nmr'] = samplenmr;

import sampleoan from './sample/oan';
lib['sample']['oan'] = sampleoan;

import samplepelletHardness from './sample/pelletHardness';
lib['sample']['pelletHardness'] = samplepelletHardness;

import samplephysical from './sample/physical';
lib['sample']['physical'] = samplephysical;

import sampleraman from './sample/raman';
lib['sample']['raman'] = sampleraman;

import samplestock from './sample/stock';
lib['sample']['stock'] = samplestock;

import samplethermogravimetricAnalysis from './sample/thermogravimetricAnalysis';
lib['sample']['thermogravimetricAnalysis'] = samplethermogravimetricAnalysis;

import sampleuv from './sample/uv';
lib['sample']['uv'] = sampleuv;

import samplevideo from './sample/video';
lib['sample']['video'] = samplevideo;

import samplevoidVolume from './sample/voidVolume';
lib['sample']['voidVolume'] = samplevoidVolume;

import samplexps from './sample/xps';
lib['sample']['xps'] = samplexps;

import samplexray from './sample/xray';
lib['sample']['xray'] = samplexray;

import samplexrd from './sample/xrd';
lib['sample']['xrd'] = samplexrd;

import samplexrf from './sample/xrf';
lib['sample']['xrf'] = samplexrf;

export default lib;